// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"91bb7e4a","661":"31b32810"}[chunkId] + ".chunk.js";
};